import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

const rootContainerStyle = css({
    position: "relative",
    backgroundColor: `${token("elevation.surface", "#22272B")}`,
    borderRadius: "10px",
    height: "736px",
    padding: "26px 18px",
    overflow: "visible"
});

const jswInteractiveBoardDisplay = css({
    [media.below.lg]: {
        display: "none"
    }
});

const boardHeaderStyle = css({
    marginBlockEnd: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});

const rightButtonGroupStyle = css({
    display: "flex"
});

const leftButtonGroupStyle = css({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px"
});

const buttonDividerStyle = css({
    backgroundColor: `${token("color.icon")}`,
    marginInlineStart: "16px",
    marginInlineEnd: "4px",
    width: "1px"
});

const rotateRestartButtonStyle = css({
    ":hover svg, :focus svg": {
        transform: "rotate(90deg)"
    },
    "svg": {
        "transition": "0.3s",
        "@media screen and (prefers-reduced-motion: reduce)": {
            transition: "none"
        }
    }
});

const wiggleCreateButtonStyle = css({
    "@keyframes hiThere": {
        "15%": {
            transform: "scale(1.2)"
        },
        "20%, 30%": {
            transform: "rotate(-20deg) scale(1.2)"
        },
        "25%": {
            transform: "rotate(20deg) scale(1.2)"
        },
        "35%": {
            transform: "rotate(0deg) scale(1.2)"
        },
        "50%": {
            transform: "scale(1)"
        }
    },
    "animation": "2.3s ease hiThere infinite",
    "@media screen and (prefers-reduced-motion: reduce)": {
        animation: "none"
    }
});

const fadeInRestartButtonStyle = css({
    "@keyframes fadeIn": {
        from: {
            opacity: "0"
        },
        to: {
            opacity: "1"
        }
    },
    "opacity": "0",
    "animation": "1s ease-in fadeIn 500ms forwards",

    "@media screen and (prefers-reduced-motion: reduce)": {
        animationDuration: "4s"
    }
});

const boardBodyStyle = css({
    borderRadius: "8px",
    height: "calc(100% - 56px)",
    overflowY: "auto"
});

const columnContainerStyle = css({
    display: "flex",
    gap: "12px",
    minHeight: "100%"
});

const columnTitleStyle = css({
    backgroundColor: `${token("elevation.surface.sunken", "#161A1D")}`,
    color: `${token("color.text.subtle", "#9FADBC")}`,
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    padding: "16px",
    textTransform: "uppercase",
    margin: "0px",
    lineHeight: "1.33333333"
});

const columnStyle = css({
    backgroundColor: `${token("elevation.surface.sunken", "#161A1D")}`,
    borderRadius: "8px",
    flex: "1 1 0",
    paddingInlineStart: "5px",
    paddingInlineEnd: "5px",
    minHeight: "622px"
});

// eslint-disable-next-line @compiled/no-exported-css
export {
    rootContainerStyle,
    jswInteractiveBoardDisplay,
    boardHeaderStyle,
    rightButtonGroupStyle,
    leftButtonGroupStyle,
    buttonDividerStyle,
    rotateRestartButtonStyle,
    wiggleCreateButtonStyle,
    fadeInRestartButtonStyle,
    boardBodyStyle,
    columnContainerStyle,
    columnTitleStyle,
    columnStyle
};
